import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { stepperFormValidationMapper } from "@utilities";
import { getStep7Validations } from "../../Validations/step7";
import useFormStepControl from "@hooks/useFormStepControl";
import { ActionButtons } from "../../Components";
import { ClientPlanTurn } from "./groups/ClientPlanTurn";
import { ClientPaymentForServices } from "./groups/ClientPaymentForServises";
import { ClientFundsRecCountrys } from "./groups/ClientFundsRecCountrys";
import { MainCustomers } from "./groups/MainCustomers";
import { PaymentsOut } from "./groups/PaymentsOut";
import { ClientFundsSentCountries } from "./groups/ClientFundsSentCountries";
import { ClientMainBusinessPartners } from "./groups/ClientMainBusinessPartners";
import { PlanServiceTurn } from "./groups/PlanServiceTurn";

export const FormStep7 = React.memo(() => {
  const {
    formDraft,
    submitForm,
    isSent,
    handleActionButtonClick,
    submitType,
    validateForm
  } = useFormStepControl();

  const [totalFundsCountries, setTotalFundsCountries] = useState(
    formDraft.personData?.clientFundsRecCountrys?.length
  );
  const [totalCustomers, setTotalCustomers] = useState(formDraft.personData?.mainCustom?.length);
  const [totalSentCountries, setTotalSentCountries] = useState(
    formDraft.personData?.clientFundsSentCountry?.length
  );
  const [totalBusinessPartners, setTotalBusinessPartners] = useState(
    formDraft.personData?.clientBusPartner?.length
  );

  const { handleSubmit, control, unregister } = useForm({
    resolver: (values, context) => {
      return validateForm(values, context, () =>
        stepperFormValidationMapper(
          values,
          getStep7Validations({
            totalFundsCountries,
            totalSentCountries,
            validateCustomers:
              (values.mainCustom[0].retail === false || values.mainCustom[0].retail === "0") &&
              (values.mainCustom[0].customerEmpty === false ||
                values.mainCustom[0].customerEmpty === "0"),
            validateBusinessPartners:
              values.clientBusPartner[0].clientBusPartnerEmpty === false ||
              values.clientBusPartner[0].clientBusPartnerEmpty === "0",
            totalBusinessPartners,
            totalCustomers
          })
        )
      );
    },
    mode: "onSubmit",
    context: {
      submitType
    },
    shouldFocusError: true,
    defaultValues: formDraft.personData
  });

  const onSubmit = data => {
    submitForm(data, submitType);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ClientPlanTurn control={control} />
        <ClientPaymentForServices control={control} />
        <ClientFundsRecCountrys
          control={control}
          unregister={unregister}
          totalFundsCountries={totalFundsCountries}
          setTotalFundsCountries={setTotalFundsCountries}
        />
        <MainCustomers
          control={control}
          unregister={unregister}
          totalCustomers={totalCustomers}
          setTotalCustomers={setTotalCustomers}
        />
        <PaymentsOut control={control} />
        <ClientFundsSentCountries
          control={control}
          unregister={unregister}
          totalSentCountries={totalSentCountries}
          setTotalSentCountries={setTotalSentCountries}
        />
        <ClientMainBusinessPartners
          control={control}
          unregister={unregister}
          totalBusinessPartners={totalBusinessPartners}
          setTotalBusinessPartners={setTotalBusinessPartners}
        />
        <PlanServiceTurn control={control} />
        <ActionButtons
          isLoading={isSent}
          handlePrevStep={handleActionButtonClick}
          handleNextStep={handleActionButtonClick}
        />
      </form>
    </>
  );
});
